import { ApplicationSummary as BaseApplicationSummary } from "@certn/application/src/ApplicationSummary";
import { useApplicantToPayContext } from "./ApplicantToPayContext";
import { useTranslation } from "react-i18next";

export function ApplicationSummary() {
  const { isApplicantToPay } = useApplicantToPayContext();
  const { t } = useTranslation();
  // Determine text based on applicant-to-pay status
  const alternativeHeaderText = isApplicantToPay
    ? t("Review and Confirm")
    : undefined;
  const alternativeDescriptionText = isApplicantToPay
    ? t(
        "Review the information you've provided us and confirm that it is correct."
      )
    : undefined;
  const alternativeSubmitButtonText = isApplicantToPay
    ? t("Confirm Information")
    : undefined;

  return (
    <BaseApplicationSummary
      alternativeHeaderText={alternativeHeaderText}
      alternativeDescriptionText={alternativeDescriptionText}
      alternativeSubmitButtonText={alternativeSubmitButtonText}
    />
  );
}
